import { useCallback, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import useDismiss from "./useDismiss";
import styles from "./FilterDropdown.module.css";

// Square filter button that opens a single-select list. `value` of null means "All".
export default function FilterDropdown({ label, options, value, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(open, close, rootRef);

  const selected = options.find((option) => option.value === value);

  const choose = (nextValue) => {
    onChange(nextValue);
    setOpen(false);
  };

  return (
    <div className={styles.root} ref={rootRef}>
      <button
        type="button"
        className={`${styles.trigger} ${selected ? styles.triggerActive : ""} d-flex align-items-center`}
        onClick={() => setOpen((isOpen) => !isOpen)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {selected ? `${label}: ${selected.label}` : label}
        <ChevronDown
          size={24}
          strokeWidth={1.75}
          className={open ? styles.chevronOpen : ""}
          aria-hidden="true"
        />
      </button>

      {open ? (
        <ul
          className={`${styles.menu} ${options.some((option) => option.description) ? styles.menuWide : ""}`}
          role="listbox"
          aria-label={label}
        >
          {[{ value: null, label: "All" }, ...options].map((option) => {
            const isSelected = option.value === value;

            return (
              <li key={option.label}>
                <button
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  className={`${styles.option} d-flex align-items-center justify-content-between`}
                  onClick={() => choose(option.value)}
                >
                  <span>
                    {option.label}
                    {option.description ? (
                      <span className={styles.description}>{option.description}</span>
                    ) : null}
                  </span>
                  {isSelected ? <Check size={14} strokeWidth={2} aria-hidden="true" /> : null}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
